export const socialMinerInit = config => {
  const socialMiner = `
    try{
      !function (a) { var b, c = "soclminer-jssdk", d = a.getElementsByTagName("script")[0]; a.getElementById(c) || (b = a.createElement("script"), b.src = "https://plugins.soclminer.com.br/v3/sdk/all.min.js", d.parentNode.insertBefore(b, d)) }(document), window.soclInit = function () { socl.start("${config?.socialMiner?.id}") };
      } catch(e) {
          console.log(e);
      }
  `;

  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.async = 1;
  script.text = socialMiner;
  head.appendChild(script);
};
